import React, { Component } from "react";
import Header from "../components/header";
import HistrorySearch from "../components/histrory-search";
import OrderHistoryTable from "../components/orderHistoryTable";
import db from "../firebase";

export default class OrderHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [
        {
          id: 1,
          status: "....",
          customer: "Jon",
          phone: 354455,
          type: "type",
          paymentMode: "paypal",
          total: "200",
          channel: "channel",
          orderedAt: "2/2/2022",
          rating: "10",
        },
      ],
      columns: [
        { field: "id", headerName: "ID", width: 70 },
        { field: "status", headerName: "Status", width: 130 },
        { field: "customer", headerName: "Customer", width: 130 },
        { field: "phone", headerName: "Phone N*", width: 130 },
        { field: "type", headerName: "Type", width: 130 },
        { field: "paymentMode", headerName: "Payment Mode", width: 130 },
        { field: "total", headerName: "Total", width: 130 },
        { field: "channel", headerName: "Channel", width: 130 },
        { field: "orderedAt", headerName: "Ordered at", width: 130 },
        { field: "rating", headerName: "Rating", width: 130 },
      ],
      user: JSON.parse(localStorage.getItem("Ubytes")),
    };
  }
  async componentDidMount() {
    await this.loadOrders();
  }
  loadOrders = async () => {
    let orderList = [];
    if (
      this.state.user.role === "Branch" ||
      this.state.user.role === "Waiter"
    ) {
      let orders = await db
        .collection("orders")
        .where("of", "==", this.state.user.of)
        .get();
      orders.forEach((order) => {
        let uid = order.data();
        uid["id"] = order.id;
        orderList.push(uid);
      });
    }
    if (this.state.user.role === "Merchant") {
      let orders = await db
        .collection("orders")
        .where("ofMerchant", "==", this.state.user.of)
        .get();
      orders.forEach((order) => {
        let uid = order.data();
        uid["id"] = order.id;
        orderList.push(uid);
      });
    }
    this.setState({ orders: orderList });
  };
  render() {
    return (
      <div className="order-history-body">
        <Header page="Order History"></Header>
        <div className="headers">
          <p>Order History</p>
        </div>
        <HistrorySearch></HistrorySearch>
        <OrderHistoryTable
          columns={this.state.columns}
          rows={this.state.orders}
        />
      </div>
    );
  }
}
